import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DecimalHelper } from "@/helpers";
import { useAppDispatch, useAppSelector } from "@/stores";
import {
  tenantDailyReportWithdrawSelects,
  tenantDailyReportWithdrawThunks,
} from "./store";
// components
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { ReportWithdrawItem } from "@/domains/report";

export const TenantDailyReportWithdrawListPage = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const loading = useAppSelector(tenantDailyReportWithdrawSelects.loading);

  const items = useAppSelector(tenantDailyReportWithdrawSelects.items);

  useEffect(() => {
    void dispatch(tenantDailyReportWithdrawThunks.list());
  }, [dispatch]);

  const columns: ColumnsType<ReportWithdrawItem> = [
    {
      width: 100,
      title: t("domains.Report.date"),
      dataIndex: "date",
    },
    {
      width: 100,
      title: t("domains.Report.recordCount"),
      align: "right",
      key: "count",
      render(_, { count }) {
        return <div className="t:right">{DecimalHelper.locale(count)}</div>;
      },
    },
    {
      width: 150,
      title: t("domains.Report.applyTotalUnit"),
      align: "right",
      key: "amount",
      render(_, { amount }) {
        return <div className="t:right">{DecimalHelper.locale(amount)}</div>;
      },
    },
    {
      width: 150,
      title: t("domains.Report.totalExpend"),
      align: "right",
      key: "expend",
      render(_, { expend }) {
        return <div className="t:right">{DecimalHelper.locale(expend)}</div>;
      },
    },
    {
      title: "",
      render() {
        return <div className="t:right"></div>;
      },
    },
  ];

  return (
    <div className="flex flex:col gap:8">
      <Table
        rowKey="id"
        tableLayout="fixed"
        loading={loading}
        columns={columns}
        dataSource={items}
        scroll={{ x: "1600px" }}
      ></Table>
    </div>
  );
};
